var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { attrs: { "data-component": "agent-profile-popup-info" } },
    [
      _c("agent-avatar", {
        attrs: { person: _vm.agent, avatar: _vm.avatar, width: 64 },
      }),
      _vm._v(" "),
      _c("div", { attrs: { "data-text": "name" } }, [
        _vm._v(
          "\n    " + _vm._s(_vm.agentMultiUserName || _vm.agentName) + "\n  "
        ),
      ]),
      _vm._v(" "),
      _c("div", { attrs: { "data-text": "email" } }, [
        _vm._v("\n    " + _vm._s(_vm.agent.email) + "\n  "),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }